import { useRef, useEffect } from 'react';

const ConnectPlaidAccount = ({
    launchConnect = false
}) => {
    const btnRef = useRef(null);

    const handleConnectClick = async (e) => {
        e.preventDefault();

    }

    useEffect(() => {
        if (launchConnect === 'plaid') {
            btnRef.current.click();
        }
    }, [launchConnect]);

    return (
        <button className="button button-blue button-slim" onClick={handleConnectClick} ref={btnRef}>
            Connect Your Accounts
        </button>
    );
}

export default ConnectPlaidAccount;
